import React, { Component } from 'react';
import * as Styles from './Styles';
import SvgDeclaration from '../../others/svg_dist/Declaration';
import { ConnectedProps, connect } from 'react-redux';
import { AppState } from '../../core/Store';
import * as FormManager from '../../reducers/ui/form';
import * as DictionariesRisksSelectors from '../../reducers/data/dictionaries/risks/selectors';

type State = {};

class BannerComponent extends Component<PropsFromRedux, State> {
	state = {};

	MULTIPLY_FACTOR = 1.5;

	calcTotalPrice = () => {
		const allSelectedRisks = this.props.allRisksDict.filter((el) =>
			this.props.allSelectedRisksIds.includes(el.riskId)
		);
		const mappedSelectedRisks = allSelectedRisks.map((el) => {
			if (el.riskId <= 6 && this.props.extendedOcCoverageSelected) {
				return {
					...el,
					riskContribution:
						el.riskContribution * this.MULTIPLY_FACTOR,
				};
			}
			return el;
		});

		if (mappedSelectedRisks.length === 0) {
			return '0.00';
		}

		if (mappedSelectedRisks.length === 1) {
			return mappedSelectedRisks[0].riskContribution;
		}

		return mappedSelectedRisks
			.map((el) => el.riskContribution)
			.reduce((prev, current) => (prev += current));
	};

	render() {
		return (
			<Styles.Wrapper>
				<Styles.ContentContainer>
					<Styles.HeadingsContainer>
						<Styles.HeadingFont>
							<span>Dziękujemy</span> za przystąpienie
						</Styles.HeadingFont>
						<Styles.HeadingFont>
							do programu ubezpieczenia!
						</Styles.HeadingFont>
						<Styles.GenericFont style={{ marginTop: '16px' }}>
							Twój wniosek został pomyślnie złożony, a teraz
							pozostał Ci już ostatni krok,
						</Styles.GenericFont>
						<Styles.GenericFont>
							aby zapewnić sobie kompleksową ochronę
							ubezpieczeniową.
						</Styles.GenericFont>
					</Styles.HeadingsContainer>
					<Styles.ContributionInfoContainer>
						<Styles.ContributionDecor>
							<SvgDeclaration />
						</Styles.ContributionDecor>
						<Styles.InfoContentContainer>
							<Styles.GenericFont style={{ marginTop: '10px' }}>
								W celu sfinalizowania procesu, prosimy o
								opłacenie składki ubezpieczeniowej.
							</Styles.GenericFont>
							<Styles.ContributionContainer>
								<p>Twoja składka ubezpieczeniowa wynosi:</p>
								<p>{`${this.calcTotalPrice()} zł`}</p>
							</Styles.ContributionContainer>
						</Styles.InfoContentContainer>
					</Styles.ContributionInfoContainer>
					{this.props.paywallUrl && (
						<Styles.PaywallContainer>
							<Styles.PaywallButton
								onClick={() => {
									const tempAnchor =
										document.createElement('a');
									tempAnchor.href =
										this.props.paywallUrl || '/';
									tempAnchor.click();
								}}
							>
								Zapłać Składkę On-line
							</Styles.PaywallButton>
						</Styles.PaywallContainer>
					)}
				</Styles.ContentContainer>
			</Styles.Wrapper>
		);
	}
}

interface Own {}

const connector = connect(
	(state: AppState, own: Own) => {
		const risksKop = DictionariesRisksSelectors.getRisksKop(state);
		const risksNnw = DictionariesRisksSelectors.getRisksNnw(state);
		const risksNnwKlauzule =
			DictionariesRisksSelectors.getRisksNnwKlauzule(state);
		const risksOc = DictionariesRisksSelectors.getRisksOc(state);

		return {
			paywallUrl: FormManager.Selectors.getPaywallUrl(state),
			contributionSum: FormManager.Selectors.getContributionSum(state),
			allSelectedRisksIds:
				FormManager.Selectors.getSelectedRisksIds(state),
			extendedOcCoverageSelected:
				FormManager.Selectors.getExtendedOcCoverageSelected(state),
			allRisksDict: [
				...risksKop,
				...risksNnw,
				...risksNnwKlauzule,
				...risksOc,
			],
		};
	},
	(dispatch) => ({})
);

export type PropsFromRedux = ConnectedProps<typeof connector> & Own;

const Banner = connector(BannerComponent);
export default Banner;
